/* eslint-disable max-len */
const { createAction } = require('../helpers')
const {
  GET_ADMIN_CONSULTATIONS_LIST,
  GET_ADMIN_CONSULTATIONS_LIST_SUCCESS,
  GET_ADMIN_CONSULTATIONS_LIST_ERROR,
  GET_ADMIN_CONSULTATIONS_LIST_RESET,
  SEND_ADMIN_CONSULTATIONS_CSV_EMAIL,
  SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_SUCCESS,
  SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_ERROR,
  SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_RESET,
  GET_ADMIN_CONSULTATION,
  GET_ADMIN_CONSULTATION_SUCCESS,
  GET_ADMIN_CONSULTATION_ERROR,
  GET_ADMIN_CONSULTATION_RESET,
  CREATE_ADMIN_CONSULTATION,
  CREATE_ADMIN_CONSULTATION_SUCCESS,
  CREATE_ADMIN_CONSULTATION_ERROR,
  CREATE_ADMIN_CONSULTATION_RESET,
  UPDATE_ADMIN_CONSULTATION,
  UPDATE_ADMIN_CONSULTATION_SUCCESS,
  UPDATE_ADMIN_CONSULTATION_ERROR,
  UPDATE_ADMIN_CONSULTATION_RESET,
  DELETE_ADMIN_CONSULTATION,
  DELETE_ADMIN_CONSULTATION_SUCCESS,
  DELETE_ADMIN_CONSULTATION_ERROR,
  DELETE_ADMIN_CONSULTATION_RESET,
  UPDATE_STATUS_ADMIN_CONSULTATION,
  UPDATE_STATUS_ADMIN_CONSULTATION_SUCCESS,
  UPDATE_STATUS_ADMIN_CONSULTATION_ERROR,
  UPDATE_STATUS_ADMIN_CONSULTATION_RESET,

  GET_CONSULTATIONS_LIST,
  GET_CONSULTATIONS_LIST_ERROR,
  GET_CONSULTATIONS_LIST_RESET,
  GET_CONSULTATIONS_LIST_SUCCESS,
  GET_AVAILABLE_CONSULTATIONS_LIST,
  GET_AVAILABLE_CONSULTATIONS_LIST_SUCCESS,
  GET_AVAILABLE_CONSULTATIONS_LIST_ERROR,
  GET_AVAILABLE_CONSULTATIONS_LIST_RESET,
  CREATE_CONSULTATION,
  CREATE_CONSULTATION_ERROR,
  CREATE_CONSULTATION_RESET,
  CREATE_CONSULTATION_SUCCESS,
  GET_CONSULTATION_HISTORY_LIST,
  GET_CONSULTATION_HISTORY_LIST_SUCCESS,
  GET_CONSULTATION_HISTORY_LIST_ERROR,
  GET_CONSULTATION_HISTORY_LIST_RESET,
  GET_CONSULTATION_HISTORY_DETAILS,
  GET_CONSULTATION_HISTORY_SUCCESS,
  GET_CONSULTATION_HISTORY_ERROR,
  GET_CONSULTATION_HISTORY_RESET,
  GET_DOCTOR_CONSULTATION_HISTORY_LIST,
  GET_DOCTOR_CONSULTATION_HISTORY_LIST_SUCCESS,
  GET_DOCTOR_CONSULTATION_HISTORY_LIST_ERROR,
  GET_DOCTOR_CONSULTATION_HISTORY_LIST_RESET,
  GET_DOCTOR_CONSULTATION_OVERVIEW,
  GET_DOCTOR_CONSULTATION_OVERVIEW_SUCCESS,
  GET_DOCTOR_CONSULTATION_OVERVIEW_ERROR,
  GET_DOCTOR_CONSULTATION_OVERVIEW_RESET,
  ASSIGN_DOC_TO_CONSULTATION,
  ASSIGN_DOC_TO_CONSULTATION_SUCCESS,
  ASSIGN_DOC_TO_CONSULTATION_ERROR,
  ASSIGN_DOC_TO_CONSULTATION_RESET,
  SET_CONSULTATION_PREFERENCE,
  SET_CONSULTATION_PREFERENCE_SUCCESS,
  SET_CONSULTATION_PREFERENCE_ERROR,
  SET_CONSULTATION_PREFERENCE_RESET,
  GET_PATIENT_RECORD,
  GET_PATIENT_RECORD_SUCCESS,
  GET_PATIENT_RECORD_ERROR,
  GET_PATIENT_RECORD_RESET,
  POST_DOCTOR_NOTES,
  POST_DOCTOR_NOTES_SUCCESS,
  POST_DOCTOR_NOTES_ERROR,
  POST_DOCTOR_NOTES_RESET,
  POST_DOCTOR_MC,
  POST_DOCTOR_MC_SUCCESS,
  POST_DOCTOR_MC_ERROR,
  POST_DOCTOR_MC_RESET,
  POST_DOCTOR_REFERRAL,
  POST_DOCTOR_REFERRAL_SUCCESS,
  POST_DOCTOR_REFERRAL_ERROR,
  POST_DOCTOR_REFERRAL_RESET,
  END_DOCTOR_CONSULTATION,
  END_DOCTOR_CONSULTATION_SUCCESS,
  END_DOCTOR_CONSULTATION_ERROR,
  END_DOCTOR_CONSULTATION_RESET,
  SEND_AUDIO_CALL_REQUEST_BY_DOCTOR,
  SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_SUCCESS,
  SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_ERROR,
  SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_RESET,
  GET_DOCTOR_TWILIO_TOKEN,
  GET_DOCTOR_TWILIO_TOKEN_SUCCESS,
  GET_DOCTOR_TWILIO_TOKEN_ERROR,
  GET_DOCTOR_TWILIO_TOKEN_RESET,
  POST_DOCTOR_CONSULTATION_TIME_LAPSED,
  POST_DOCTOR_CONSULTATION_TIME_LAPSED_SUCCESS,
  POST_DOCTOR_CONSULTATION_TIME_LAPSED_ERROR,
  POST_DOCTOR_CONSULTATION_TIME_LAPSED_RESET,
  GET_MD_REFERRAL_NEW_LINK,
  GET_MD_REFERRAL_NEW_LINK_SUCCESS,
  GET_MD_REFERRAL_NEW_LINK_ERROR,
  GET_MD_REFERRAL_NEW_LINK_RESET,
  GET_MD_MC_NEW_LINK,
  GET_MD_MC_NEW_LINK_SUCCESS,
  GET_MD_MC_NEW_LINK_ERROR,
  GET_MD_MC_NEW_LINK_RESET,
  CHECK_PATIENT_CONSULTATION_STATUS,
  CHECK_PATIENT_CONSULTATION_STATUS_SUCCESS,
  CHECK_PATIENT_CONSULTATION_STATUS_ERROR,
  CHECK_PATIENT_CONSULTATION_STATUS_RESET,
  VERIFY_TRANSACTION_AMOUNT,
  VERIFY_TRANSACTION_AMOUNT_SUCCESS,
  VERIFY_TRANSACTION_AMOUNT_ERROR,
  VERIFY_TRANSACTION_AMOUNT_RESET,
  GET_PRESCRIPTION_ID,
  GET_PRESCRIPTION_ID_SUCCESS,
  GET_PRESCRIPTION_ID_ERROR,
  GET_PRESCRIPTION_ID_RESET,
  POST_REGENERATE_AGORA_TOKEN,
  POST_REGENERATE_AGORA_TOKEN_SUCCESS,
  POST_REGENERATE_AGORA_TOKEN_ERROR,
  POST_REGENERATE_AGORA_TOKEN_RESET,
} = require('./constants')

// For Admin Users
const getAdminConsultationsList = ({
  type, take, skip, from, to, key, status, search, userId, doctorId, manual, download, hospitalReferral, id,
}) => createAction(GET_ADMIN_CONSULTATIONS_LIST, {
  type, take, skip, from, to, key, status, search, userId, doctorId, manual, download, hospitalReferral, id,
})
const getAdminConsultationsListSuccess = data => createAction(GET_ADMIN_CONSULTATIONS_LIST_SUCCESS, { data })
const getAdminConsultationsListError = error => createAction(GET_ADMIN_CONSULTATIONS_LIST_ERROR, { error })
const getAdminConsultationsListReset = () => createAction(GET_ADMIN_CONSULTATIONS_LIST_RESET)

// For Admin Users
const sendAdminConsultationsCSVEmail = ({
  type, take, skip, from, to, key, status, search, userId, doctorId, manual, download, hospitalReferral, id,
}) => createAction(SEND_ADMIN_CONSULTATIONS_CSV_EMAIL, {
  type, take, skip, from, to, key, status, search, userId, doctorId, manual, download, hospitalReferral, id,
})
const sendAdminConsultationsCSVEmailSuccess = data => createAction(SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_SUCCESS, { data })
const sendAdminConsultationsCSVEmailError = error => createAction(SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_ERROR, { error })
const sendAdminConsultationsCSVEmailReset = () => createAction(SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_RESET)

// For Admin Users
const getAdminConsultation = id => createAction(GET_ADMIN_CONSULTATION, { id })
const getAdminConsultationSuccess = data => createAction(GET_ADMIN_CONSULTATION_SUCCESS, { data })
const getAdminConsultationError = error => createAction(GET_ADMIN_CONSULTATION_ERROR, { error })
const getAdminConsultationReset = () => createAction(GET_ADMIN_CONSULTATION_RESET)

// For Admin Users
const createAdminConsultation = caseData => createAction(CREATE_ADMIN_CONSULTATION, { caseData })
const createAdminConsultationSuccess = data => createAction(CREATE_ADMIN_CONSULTATION_SUCCESS, { data })
const createAdminConsultationError = error => createAction(CREATE_ADMIN_CONSULTATION_ERROR, { error })
const createAdminConsultationReset = () => createAction(CREATE_ADMIN_CONSULTATION_RESET)

// For Admin Users
const updateAdminConsultation = ({ id, caseData }) => createAction(UPDATE_ADMIN_CONSULTATION, { id, caseData })
const updateAdminConsultationSuccess = data => createAction(UPDATE_ADMIN_CONSULTATION_SUCCESS, { data })
const updateAdminConsultationError = error => createAction(UPDATE_ADMIN_CONSULTATION_ERROR, { error })
const updateAdminConsultationReset = () => createAction(UPDATE_ADMIN_CONSULTATION_RESET)

// For Admin Users
const deleteAdminConsultation = ({ id }) => createAction(DELETE_ADMIN_CONSULTATION, { id })
const deleteAdminConsultationSuccess = data => createAction(DELETE_ADMIN_CONSULTATION_SUCCESS, { data })
const deleteAdminConsultationError = error => createAction(DELETE_ADMIN_CONSULTATION_ERROR, { error })
const deleteAdminConsultationReset = () => createAction(DELETE_ADMIN_CONSULTATION_RESET)

// For Admin Users
const updateStatusAdminConsultation = ({ id, bodyData }) => createAction(UPDATE_STATUS_ADMIN_CONSULTATION, { id, bodyData })
const updateStatusAdminConsultationSuccess = data => createAction(UPDATE_STATUS_ADMIN_CONSULTATION_SUCCESS, { data })
const updateStatusAdminConsultationError = error => createAction(UPDATE_STATUS_ADMIN_CONSULTATION_ERROR, { error })
const updateStatusAdminConsultationReset = () => createAction(UPDATE_STATUS_ADMIN_CONSULTATION_RESET)

const getConsultation = () => createAction(GET_CONSULTATIONS_LIST)
const getConsultationSuccess = data => createAction(GET_CONSULTATIONS_LIST_SUCCESS, { data })
const getConsultationError = error => createAction(GET_CONSULTATIONS_LIST_ERROR, { error })
const getConsultationReset = () => createAction(GET_CONSULTATIONS_LIST_RESET)

const getAvailableConsultations = status => createAction(GET_AVAILABLE_CONSULTATIONS_LIST, { status })
const getAvailableConsultationsSuccess = data => createAction(GET_AVAILABLE_CONSULTATIONS_LIST_SUCCESS, { data })
const getAvailableConsultationsError = error => createAction(GET_AVAILABLE_CONSULTATIONS_LIST_ERROR, { error })
const resetAvailableConsultations = () => createAction(GET_AVAILABLE_CONSULTATIONS_LIST_RESET)

const createConsultation = data => createAction(CREATE_CONSULTATION, { data })
const createConsultationSuccess = data => createAction(CREATE_CONSULTATION_SUCCESS, { data })
const createConsultationError = error => createAction(CREATE_CONSULTATION_ERROR, { error })
const createConsultationReset = () => createAction(CREATE_CONSULTATION_RESET)

// For Patient Side
const getConsultationHistoryList = ({
  type, from, to, key,
}) => createAction(GET_CONSULTATION_HISTORY_LIST, {
  type, from, to, key,
})
const getConsultationHistoryListSuccess = data => createAction(GET_CONSULTATION_HISTORY_LIST_SUCCESS, { data })
const getConsultationHistoryListError = error => createAction(GET_CONSULTATION_HISTORY_LIST_ERROR, { error })
const getConsultationHistoryListReset = () => createAction(GET_CONSULTATION_HISTORY_LIST_RESET)

const getConsultationHistoryDetails = id => createAction(GET_CONSULTATION_HISTORY_DETAILS, { id })
const getConsultationHistoryDetailsSuccess = data => createAction(GET_CONSULTATION_HISTORY_SUCCESS, { data })
const getConsultationHistoryDetailsError = error => createAction(GET_CONSULTATION_HISTORY_ERROR, { error })
const getConsultationHistoryDetailsReset = () => createAction(GET_CONSULTATION_HISTORY_RESET)

const getDoctorConsultationHistoryList = ({
  type, gpBtn, name, from, to, key,
}) => createAction(GET_DOCTOR_CONSULTATION_HISTORY_LIST, {
  type, gpBtn, name, from, to, key,
})
const getDoctorConsultationHistoryListSuccess = data => createAction(GET_DOCTOR_CONSULTATION_HISTORY_LIST_SUCCESS, { data })
const getDoctorConsultationHistoryListError = error => createAction(GET_DOCTOR_CONSULTATION_HISTORY_LIST_ERROR, { error })
const getDoctorConsultationHistoryListReset = () => createAction(GET_DOCTOR_CONSULTATION_HISTORY_LIST_RESET)

const getDoctorConsultationOverview = id => createAction(GET_DOCTOR_CONSULTATION_OVERVIEW, { id })
const getDoctorConsultationOverviewSuccess = data => createAction(GET_DOCTOR_CONSULTATION_OVERVIEW_SUCCESS, { data })
const getDoctorConsultationOverviewError = error => createAction(GET_DOCTOR_CONSULTATION_OVERVIEW_ERROR, { error })
const getDoctorConsultationOverviewReset = () => createAction(GET_DOCTOR_CONSULTATION_OVERVIEW_RESET)

const assignDocToConsultation = id => createAction(ASSIGN_DOC_TO_CONSULTATION, { id })
const assignDocToConsultationSuccess = data => createAction(ASSIGN_DOC_TO_CONSULTATION_SUCCESS, { data })
const assignDocToConsultationError = error => createAction(ASSIGN_DOC_TO_CONSULTATION_ERROR, { error })
const assignDocToConsultationReset = () => createAction(ASSIGN_DOC_TO_CONSULTATION_RESET)

const setConsultationPreference = ({ mode, id }) => createAction(SET_CONSULTATION_PREFERENCE, { mode, id })
const setConsultationPreferenceSuccess = data => createAction(SET_CONSULTATION_PREFERENCE_SUCCESS, { data })
const setConsultationPreferenceError = error => createAction(SET_CONSULTATION_PREFERENCE_ERROR, { error })
const setConsultationPreferenceReset = () => createAction(SET_CONSULTATION_PREFERENCE_RESET)

const getPatientRecord = ({
  doctorId, take, skip, mr, ignoreId, id,
}) => createAction(GET_PATIENT_RECORD, {
  doctorId, take, skip, mr, ignoreId, id,
})
const getPatientRecordSuccess = data => createAction(GET_PATIENT_RECORD_SUCCESS, { data })
const getPatientRecordError = error => createAction(GET_PATIENT_RECORD_ERROR, { error })
const getPatientRecordReset = () => createAction(GET_PATIENT_RECORD_RESET)

const postDoctorNotes = data => createAction(POST_DOCTOR_NOTES, { data })
const postDoctorNotesSuccess = data => createAction(POST_DOCTOR_NOTES_SUCCESS, { data })
const postDoctorNotesError = error => createAction(POST_DOCTOR_NOTES_ERROR, { error })
const postDoctorNotesReset = () => createAction(POST_DOCTOR_NOTES_RESET)

const postDoctorMC = ({
  diagnosis, from, to, doctorId, id,
}) => createAction(POST_DOCTOR_MC, {
  diagnosis, from, to, doctorId, id,
})
const postDoctorMCSuccess = data => createAction(POST_DOCTOR_MC_SUCCESS, { data })
const postDoctorMCError = error => createAction(POST_DOCTOR_MC_ERROR, { error })
const postDoctorMCReset = () => createAction(POST_DOCTOR_MC_RESET)

const postDoctorReferral = ({
  title, department, notes, doctorId, id,
}) => createAction(POST_DOCTOR_REFERRAL, {
  title, department, notes, doctorId, id,
})
const postDoctorReferralSuccess = data => createAction(POST_DOCTOR_REFERRAL_SUCCESS, { data })
const postDoctorReferralError = error => createAction(POST_DOCTOR_REFERRAL_ERROR, { error })
const postDoctorReferralReset = () => createAction(POST_DOCTOR_REFERRAL_RESET)

const endDoctorConsultation = ({ doctorId, consultationId, data }) => createAction(END_DOCTOR_CONSULTATION, { doctorId, consultationId, data })
const endDoctorConsultationSuccess = data => createAction(END_DOCTOR_CONSULTATION_SUCCESS, { data })
const endDoctorConsultationError = error => createAction(END_DOCTOR_CONSULTATION_ERROR, { error })
const endDoctorConsultationReset = () => createAction(END_DOCTOR_CONSULTATION_RESET)

const sendAudioCallRequestByDoctor = ({ doctorId, consultationId }) => createAction(SEND_AUDIO_CALL_REQUEST_BY_DOCTOR, { doctorId, consultationId })
const sendAudioCallRequestByDoctorSuccess = data => createAction(SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_SUCCESS, { data })
const sendAudioCallRequestByDoctorError = error => createAction(SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_ERROR, { error })
const sendAudioCallRequestByDoctorReset = () => createAction(SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_RESET)

const getDoctorTwilioToken = () => createAction(GET_DOCTOR_TWILIO_TOKEN)
const getDoctorTwilioTokenSuccess = data => createAction(GET_DOCTOR_TWILIO_TOKEN_SUCCESS, { data })
const getDoctorTwilioTokenError = error => createAction(GET_DOCTOR_TWILIO_TOKEN_ERROR, { error })
const getDoctorTwilioTokenReset = () => createAction(GET_DOCTOR_TWILIO_TOKEN_RESET)

const postDoctorConsultationTimeLapsed = ({
  start, end, doctorId, id,
}) => createAction(POST_DOCTOR_CONSULTATION_TIME_LAPSED, {
  start, end, doctorId, id,
})
const postDoctorConsultationTimeLapsedSuccess = data => createAction(POST_DOCTOR_CONSULTATION_TIME_LAPSED_SUCCESS, { data })
const postDoctorConsultationTimeLapsedError = error => createAction(POST_DOCTOR_CONSULTATION_TIME_LAPSED_ERROR, { error })
const postDoctorConsultationTimeLapsedReset = () => createAction(POST_DOCTOR_CONSULTATION_TIME_LAPSED_RESET)

const getMDReferralNewLink = ({ doctorId, id }) => createAction(GET_MD_REFERRAL_NEW_LINK, { doctorId, id })
const getMDReferralNewLinkSuccess = data => createAction(GET_MD_REFERRAL_NEW_LINK_SUCCESS, { data })
const getMDReferralNewLinkError = error => createAction(GET_MD_REFERRAL_NEW_LINK_ERROR, { error })
const getMDReferralNewLinkReset = () => createAction(GET_MD_REFERRAL_NEW_LINK_RESET)

const getMDMcNewLink = ({ doctorId, id }) => createAction(GET_MD_MC_NEW_LINK, { doctorId, id })
const getMDMcNewLinkSuccess = data => createAction(GET_MD_MC_NEW_LINK_SUCCESS, { data })
const getMDMcNewLinkError = error => createAction(GET_MD_MC_NEW_LINK_ERROR, { error })
const getMDMcNewLinkReset = () => createAction(GET_MD_MC_NEW_LINK_RESET)

const checkPatientConsultationStatus = id => createAction(CHECK_PATIENT_CONSULTATION_STATUS, { id })
const checkPatientConsultationStatusSuccess = data => createAction(CHECK_PATIENT_CONSULTATION_STATUS_SUCCESS, { data })
const checkPatientConsultationStatusError = error => createAction(CHECK_PATIENT_CONSULTATION_STATUS_ERROR, { error })
const checkPatientConsultationStatusReset = () => createAction(CHECK_PATIENT_CONSULTATION_STATUS_RESET)

const verifyTransactionAmount = id => createAction(VERIFY_TRANSACTION_AMOUNT, { id })
const verifyTransactionAmountSuccess = data => createAction(VERIFY_TRANSACTION_AMOUNT_SUCCESS, { data })
const verifyTransactionAmountError = error => createAction(VERIFY_TRANSACTION_AMOUNT_ERROR, { error })
const verifyTransactionAmountReset = () => createAction(VERIFY_TRANSACTION_AMOUNT_RESET)

const getPrescriptionId = ({ data, doctorId, id }) => createAction(GET_PRESCRIPTION_ID, { data, doctorId, id })
const getPrescriptionIdSuccess = data => createAction(GET_PRESCRIPTION_ID_SUCCESS, { data })
const getPrescriptionIdError = error => createAction(GET_PRESCRIPTION_ID_ERROR, { error })
const getPrescriptionIdReset = () => createAction(GET_PRESCRIPTION_ID_RESET)

const postRegenerateAgoraToken = ({ regenerate, status, consultationId }) => createAction(POST_REGENERATE_AGORA_TOKEN, { regenerate, status, consultationId })
const postRegenerateAgoraTokenSuccess = data => createAction(POST_REGENERATE_AGORA_TOKEN_SUCCESS, { data })
const postRegenerateAgoraTokenError = error => createAction(POST_REGENERATE_AGORA_TOKEN_ERROR, { error })
const postRegenerateAgoraTokenReset = () => createAction(POST_REGENERATE_AGORA_TOKEN_RESET)

module.exports = {
  getAdminConsultationsList,
  getAdminConsultationsListSuccess,
  getAdminConsultationsListError,
  getAdminConsultationsListReset,
  sendAdminConsultationsCSVEmail,
  sendAdminConsultationsCSVEmailSuccess,
  sendAdminConsultationsCSVEmailError,
  sendAdminConsultationsCSVEmailReset,
  getAdminConsultation,
  getAdminConsultationSuccess,
  getAdminConsultationError,
  getAdminConsultationReset,
  createAdminConsultation,
  createAdminConsultationSuccess,
  createAdminConsultationError,
  createAdminConsultationReset,
  updateAdminConsultation,
  updateAdminConsultationSuccess,
  updateAdminConsultationError,
  updateAdminConsultationReset,
  deleteAdminConsultation,
  deleteAdminConsultationSuccess,
  deleteAdminConsultationError,
  deleteAdminConsultationReset,
  updateStatusAdminConsultation,
  updateStatusAdminConsultationSuccess,
  updateStatusAdminConsultationError,
  updateStatusAdminConsultationReset,

  getConsultation,
  getConsultationSuccess,
  getConsultationError,
  getConsultationReset,
  getAvailableConsultations,
  getAvailableConsultationsSuccess,
  getAvailableConsultationsError,
  resetAvailableConsultations,
  createConsultation,
  createConsultationSuccess,
  createConsultationError,
  createConsultationReset,
  getConsultationHistoryList,
  getConsultationHistoryListSuccess,
  getConsultationHistoryListError,
  getConsultationHistoryListReset,
  getConsultationHistoryDetails,
  getConsultationHistoryDetailsSuccess,
  getConsultationHistoryDetailsError,
  getConsultationHistoryDetailsReset,
  getDoctorConsultationHistoryList,
  getDoctorConsultationHistoryListSuccess,
  getDoctorConsultationHistoryListError,
  getDoctorConsultationHistoryListReset,
  getDoctorConsultationOverview,
  getDoctorConsultationOverviewSuccess,
  getDoctorConsultationOverviewError,
  getDoctorConsultationOverviewReset,
  assignDocToConsultation,
  assignDocToConsultationSuccess,
  assignDocToConsultationError,
  assignDocToConsultationReset,
  setConsultationPreference,
  setConsultationPreferenceSuccess,
  setConsultationPreferenceError,
  setConsultationPreferenceReset,
  getPatientRecord,
  getPatientRecordSuccess,
  getPatientRecordError,
  getPatientRecordReset,
  postDoctorNotes,
  postDoctorNotesSuccess,
  postDoctorNotesError,
  postDoctorNotesReset,
  postDoctorMC,
  postDoctorMCSuccess,
  postDoctorMCError,
  postDoctorMCReset,
  postDoctorReferral,
  postDoctorReferralSuccess,
  postDoctorReferralError,
  postDoctorReferralReset,
  endDoctorConsultation,
  endDoctorConsultationSuccess,
  endDoctorConsultationError,
  endDoctorConsultationReset,
  sendAudioCallRequestByDoctor,
  sendAudioCallRequestByDoctorSuccess,
  sendAudioCallRequestByDoctorError,
  sendAudioCallRequestByDoctorReset,
  getDoctorTwilioToken,
  getDoctorTwilioTokenSuccess,
  getDoctorTwilioTokenError,
  getDoctorTwilioTokenReset,
  postDoctorConsultationTimeLapsed,
  postDoctorConsultationTimeLapsedSuccess,
  postDoctorConsultationTimeLapsedError,
  postDoctorConsultationTimeLapsedReset,
  getMDReferralNewLink,
  getMDReferralNewLinkSuccess,
  getMDReferralNewLinkError,
  getMDReferralNewLinkReset,
  getMDMcNewLink,
  getMDMcNewLinkSuccess,
  getMDMcNewLinkError,
  getMDMcNewLinkReset,
  checkPatientConsultationStatus,
  checkPatientConsultationStatusSuccess,
  checkPatientConsultationStatusError,
  checkPatientConsultationStatusReset,
  verifyTransactionAmount,
  verifyTransactionAmountSuccess,
  verifyTransactionAmountError,
  verifyTransactionAmountReset,
  getPrescriptionId,
  getPrescriptionIdSuccess,
  getPrescriptionIdError,
  getPrescriptionIdReset,
  postRegenerateAgoraToken,
  postRegenerateAgoraTokenSuccess,
  postRegenerateAgoraTokenError,
  postRegenerateAgoraTokenReset,
}
